import { Button } from '@/components/button'
import { MainContent } from '@/components/content'
import { ArrowBack } from '@/components/icons'
import { MainLayout } from '@/components/layouts'
import { MainSidebar, MobileSidebar } from '@/components/sidebar'
import { ClubItemLoading } from '@/components/skeleton'
import { ROUTE_PLAY } from '@/constants/Routes'
import { useAppDispatch, useAppSelector } from '@/hooks/useRedux'
import { appSelector } from '@/pages/home/selectors'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getMyClubs } from '../clubSlice'
import { ClubItem } from '../components'
import { clubSelector } from '../selectors'

export const MyClubs = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { isShowDropdown } = useAppSelector(appSelector)
  const { myClubs, isLoadingMyClubs } = useAppSelector(clubSelector)

  const handleBackToClub = () => navigate(ROUTE_PLAY)

  const onGetMyClubs = () => {
    dispatch(getMyClubs())
  }

  useEffect(() => {
    onGetMyClubs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {!isShowDropdown && <MobileSidebar />}
      <MainLayout>
        <MainSidebar />
        <MainContent>
          <div className="flex flex-col gap-y-4 mb-20 lg:mb-8">
            <div className="flex items-center">
              <Button onClick={handleBackToClub} className="hover:opacity-50">
                <ArrowBack className="text-white" />
              </Button>
              <h1 className="ml-3 text-sm md:text-xl text-white font-semibold">{t('club.myClubs')}</h1>
            </div>

            <div className="flex flex-col md:flex-row gap-y-2 md:flex-wrap md:gap-2">
              {myClubs?.map((item) => <ClubItem key={item.clubId} club={item} isMyClub />)}
              {isLoadingMyClubs && (
                <>
                  <ClubItemLoading />
                  <ClubItemLoading />
                  <ClubItemLoading />
                  <ClubItemLoading />
                  <ClubItemLoading />
                  <ClubItemLoading />
                  <ClubItemLoading />
                  <ClubItemLoading />
                  <ClubItemLoading />
                </>
              )}
            </div>
            {!myClubs.length && !isLoadingMyClubs && (
              <div className="flex justify-center">
                <span className="text-white font-semibold text-opacity-60 text-center">
                  {t('common.noMoreResults')}
                </span>
              </div>
            )}
          </div>
        </MainContent>
      </MainLayout>
    </>
  )
}
